export const CURRENT_GAME_STORAGE_KEY = 'currentGame';
export const WORD_LENGTH = 5;
export const TOTAL_TRIES = 6;
